export const footer = {
    inverse: false,
    reverse: false,
    img: require("../assets/img/gcc-updated-white-logo.png"),
    facebook: "https://www.facebook.com/U.A.E.FMA",
    instagram: "https://www.instagram.com/uaefma/",
    twitter: "https://twitter.com/UAEFMA?lang=en",
    linkedin: "https://www.linkedin.com/company/u-a-e-financial-markets-association?trk=company_logo"
};
